export const text = {
  categoryCreated: 'Se ha creado la categoría.',
  categoryError: 'Se perdió la conexión. Por favor inténtalo de nuevo.'
};
